// components
import Image from 'next/image';
import VisibleLoading from '@/components/utilities/VisibleLoading';
import Link from '@/components/utilities/SmartLink';

// utilities
import { getImagePath } from '@/utils/images';

const CardsWithImageBlock = ({ cards }) => {
  return (
    <div className="mx-auto w-[90vw] py-8 xl:w-(--container-width) xl:py-16">
      <div className="flex flex-wrap gap-y-6">
        {(cards || []).map((card, index) => (
          <VisibleLoading key={card.id} delay={(index + 1) * 100}>
            {({ ref, className }) => <CardWithImage innerRef={ref} className={className} card={card} />}
          </VisibleLoading>
        ))}
      </div>
    </div>
  );
};
export default CardsWithImageBlock;

const CardWithImage = ({ innerRef, className, card }) => {
  const target = card.newWindow ? '_blank' : '_self';

  const content = (
    <>
      <div className="bg-grey-100 h-[250px] min-h-[250px] w-full overflow-hidden rounded-[8px]">
        {card?.image && (
          <Image
            src={getImagePath(card.image)}
            width={card.image.width}
            height={card.image.height}
            alt={card.image.alternativeText}
            sizes="(min-width: 1280px) 400px, (min-width: 768px) 50vw, 90vw"
            className="h-full w-full object-cover"
          />
        )}
      </div>

      <div>
        <div className="text-brand-400 txt-md mb-4 font-semibold uppercase">{card.subtitle}</div>
        <h3 className="heading-6 text-grey-950 line-clamp-2 min-h-[56px] decoration-1 underline-offset-3 group-hover:underline">
          {card.title}
        </h3>
      </div>

      <div className="text-grey-700 txt-lg line-clamp-4 flex-1">{card.text}</div>
    </>
  );

  if (card.link) {
    return (
      <div ref={innerRef} className={`basis-full xl:basis-1/3 ${className}`.trim()}>
        <div className="mx-3 h-full rounded-[20px] bg-white shadow-2xl/15">
          <Link
            ref={innerRef}
            href={card.link}
            target={target}
            className="group flex h-full flex-col gap-6 p-4"
            rel={card.newWindow ? 'noopener noreferrer' : undefined}
          >
            {content}
          </Link>
        </div>
      </div>
    );
  } else {
    return (
      <div ref={innerRef} className={`basis-full xl:basis-1/3 ${className}`.trim()}>
        <div className="mx-3 flex h-full flex-col gap-6 rounded-[20px] bg-white p-4 shadow-2xl/15">{content}</div>
      </div>
    );
  }
};
